
<template>
    <el-dialog title="产品识别码" :visible.sync="codeIdentificationDialog" width="700px" :before-close="handleDialogClose"  append-to-body :close-on-click-modal="false" class="custom-form-dialog custom-inventory-dialog">
        <div class="product_code_identification_wrap" v-loading="loading">
            <div class="product_code_identification_left">
                <h5  v-if="activeNameList.indexOf(1) > -1">已绑定产品识别码</h5>
                <div v-if="activeNameList.indexOf(1) > -1" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 1}" @click="handleClickTab(1)">编码识别</div>
                <h5  v-if="activeNameList.indexOf(2) > -1 || activeNameList.indexOf(3) > -1 || activeNameList.indexOf(4) > -1" class="mt_16">未绑定产品识别码</h5>
                <div v-if="activeNameList.indexOf(2) > -1" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 2}" @click="handleClickTab(2)">人工输入绑定</div>
                <div v-if="activeNameList.indexOf(3) > -1" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 3}" @click="handleClickTab(3)">系统录入绑定</div>
                <div v-if="activeNameList.indexOf(4) > -1" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 4}" @click="handleClickTab(4)">人工输入+规则绑定</div>
                <h5  v-if="activeNameList.indexOf(5) > -1 && product_code_list.length" class="mt_16">编码明细</h5>
                <div v-if="activeNameList.indexOf(5) > -1 && product_code_list.length" class="custom_hover_active_class  font_bold ellipsis" :class="{'active' : activeName == 5}" @click="handleClickTab(5)">已选编码明细（{{product_code_list.length}}）</div>
            </div>
            <div class="product_code_identification_right">
                <template v-if="activeName == 1">
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span> <span class="del" @click="handleClickDel">清除</span></div>
                    </div>
                    <div class="bottom">
                        <template v-if="hasError == false">
                            <el-input @input="getCodeLength" :rows="20" placeholder="请输入产品编码
批量输入需换行
请注意输入格式数字与字母的组合，纯数字或纯英文，
特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”" ref="textareaValue" type="textarea"  v-model="textareaValue" ></el-input>
                        </template>
                        <template v-else>
                            <div class="error_code_wrap">
                                <ul>
                                    <li v-for="item in codeData" >
                                        <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                            <el-input  @input="handleInputText(item)"   placeholder="" size="small" v-model="item.value"></el-input>
                                            <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                        </div>
                                        <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-if="activeName == 2">
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span> <span class="del" @click="handleClickDel">清除</span></div>
                    </div>
                    <div class="bottom">
                        <template v-if="hasError == false">
                            <el-input @input="getCodeLength" :rows="20" placeholder="请输入产品编码，批量生成需换行
请注意输入格式，推荐数字与字母的组合，纯数字或纯英文
特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”
组合示例：CP-12345678
                  cP-240918000001
数字示例：12345678
英文示例：abcdefghi
                  ABCDEFGHI
                  abcdEFGHI" ref="textareaValue" type="textarea"  v-model="textareaValue" ></el-input>

                        </template>
                        <template v-else>
                            <div class="error_code_wrap">
                                <ul>
                                    <li v-for="item in codeData" >
                                        <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                           <el-input  @input="handleInputText(item)"   placeholder="" size="small" v-model="item.value"></el-input>
                                           <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                        </div>
                                        <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </template>
                <template v-if="activeName == 3">
                    <div class="set_generate_code_input">
                        <el-input-number size="small" :controls="false" placeholder="请输入需要生成的识别码数量" :min="0" :max="9999" v-model="number"></el-input-number>
                        <el-button type="primary" size="small" @click="handleClickGenerateCode">生成编码</el-button>
                    </div>
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span></div>
                    </div>
                    <div class="bottom">
                       <div class="set_generate_code_wrap "  :class="codeData && codeData.length ? 'error_code_wrap' : ''">
                           <ul v-if="codeData && codeData.length">
                               <li v-for="item in codeData" >
                                   <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                       <el-input  @input="handleInputText(item)" readonly  placeholder="" size="small" v-model="item.value"></el-input>
                                       <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                   </div>
                                   <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                               </li>
                           </ul>
                           <p v-else>输入数量过后，根据系统规则生成产品识别码。<br>示例：CP-2409180000000001</p>
                       </div>
                    </div>
                </template>
                <template v-if="activeName == 4">
                    <div class="set_generate_code_input borderRadio">
                        <el-input size="small" placeholder="请输入自定义规则，例abc1234" v-model="rule"></el-input>
                        <el-input-number size="small" :controls="false" placeholder="请输入数量" :min="0" :max="9999"  v-model="number"></el-input-number>
                        <el-button type="primary" size="small" @click="handleClickGenerateCode">生成编码</el-button>
                    </div>
                    <div class="prompt">请输入自定义规则，规则为英文加数字，特殊符号只可输入-系统会根据所输入的规则中，包含的数字进行递增生成</div>
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{codeData.length}}条</span></div>
                    </div>
                    <div class="bottom">
                        <div class="set_generate_code_wrap height348 " :class="codeData && codeData.length ? 'error_code_wrap' : ''">
                            <ul v-if="codeData && codeData.length">
                                <li v-for="item in codeData" >
                                    <div class="code_input" :class="{'error' : (item.error && item.error!= 'true')}">
                                        <el-input  @input="handleInputText(item)"  readonly placeholder="" size="small" v-model="item.value"></el-input>
                                        <i  @click="handleClickDelCode(item)" class="el-icon-error"></i>
                                    </div>
                                    <p v-if="(item.error && item.error!= 'true') " v-text="item.error"></p>
                                </li>
                            </ul>
                            <div v-else>
                                <p>例：abc1234 </p>
                                <p style="text-indent: 2em">abc1235 </p>
                                <p style="text-indent: 2em">abc1236 </p>
                                <p style="text-indent: 2em">abc1237 </p>
                                <p style="text-indent: 2em">abc1238 </p>
                                <p style="text-indent: 2em">abc1239 </p>
                                <p style="text-indent: 2em">......</p>
                                <p style="text-indent: 2em">abc1250</p>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="activeName == 5">
                    <div class="top">
                        <div class="required title">产品识别码</div>
                        <div class="num">共 <span>{{product_code_list.length}}条</span> <span class="del" @click="handleClickDelSelected">清除</span></div>
                    </div>
                    <div class="bottom">
                        <div class="set_generate_code_wrap error_code_wrap height434">
                            <ul v-if="product_code_list && product_code_list.length>0">
                                <li v-for="(item,key) in product_code_list" :key="key">
                                    <div class="code_input" >
                                        <el-input  readonly   size="small" :value="item"></el-input>
                                        <i  @click="handleClickDelSelectedCode(item,key)" class="el-icon-error"></i>
                                    </div>
                                </li>
                            </ul>
                            <p v-else class="ta_c mt_16">暂无内容</p>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" v-if="hasError">再次校验</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" v-else>确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {generateProductCodes,generateCodes,codeCheck,identifyCodeOut,identifyCodeIn} from "@/api/index.js"
import {pagination} from '@/mixins'
export default {
    name: "code_identification",
    props: {
        codeIdentificationDialog: {
            type: Boolean,
            default: false
        },
        maxCodeIdentification:{
            type: [Number,Boolean],
            default: null
        },
        sourceType: {
            type: String,
            default: 'in'
        }, //来源 入库in  出库out
        productInfo: {
            type: Object,
            default: ()=>{}
        }, //产品  没有产品的话是点击的上面的编码识别，有产品id的话是选中产品后识别编码
        selectedCodeData: {
            type: Array,
            default: ()=> []
        }, //全部已选的产品编码
        related_info:{
            type: Object,
            default: ()=>{} //待办时的参数
        },
        relatedType: {
            type: String,
            default: ''
        },
        relatedId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            loading:false,
            BtnDisabled:false,
            codeData:[],
            activeName:1,
            oldActiveName:1,
            hasError:false,
            textareaValue:'' , //批量输入的文本
            rule:'',//自定义的规则
            number:null, //生成编码的数量
            activeNameList:[],
            product_code_list:[],
        }
    },
    mixins: [pagination],
    created() {

        if(this.sourceType == 'in'){
            if(this.relatedType){
                this.activeNameList = [1]
            }else{
                if(this.productInfo){
                    this.activeNameList = [1,2,3,4,5]
                }else{
                    this.activeNameList = [1]
                }
            }
        }else if(this.sourceType == 'out'){
            this.activeNameList = [1,5]
        }

        if(this.relatedType == 'purchase'){
            //采购入库
            this.activeNameList = [2,3,4,5]
        }else if(this.relatedType.indexOf('order') > -1 && this.productInfo){
            this.activeNameList = [1,5]
        }

        this.activeName = this.activeNameList[0]

        // 单独产品的已选编码
        if(this.productInfo && this.productInfo.code_list && this.productInfo.code_list.length > 0){
            this.product_code_list = JSON.parse(JSON.stringify(this.productInfo.code_list))
        }
    },
    methods: {
        // 系统生成编码
        handleClickGenerateCode(){
           if( this.activeName == '3'){
               let postData = {
                   product_name: this.productInfo.name,
                   num: this.number,
               }

               this.loading = true
               generateProductCodes(postData).then(res => {
                   if(res.code == 200){
                       this.codeData = []
                       res.data.forEach((item,key)=>{
                           this.codeData.push({value:item,error:'',key:key})
                       })
                   }
                   this.loading = false
               })
           }else if( this.activeName == '4'){
               let postData = {
                   product_name: this.productInfo.name,
                   num: this.number,
                   rule: this.rule,
               }
               this.loading = true
               generateCodes(postData).then(res => {
                   if(res.code == 200){
                       this.codeData = []
                       res.data.forEach((item,key)=>{
                           this.codeData.push({value:item,error:'',key:key})
                       })
                   }
                   this.loading = false
               })
           }
        },
        // 输入时获取编码数量
        getCodeLength(){
            this.$nextTick(()=>{
                var textArea = this.$refs.textareaValue
                var lines = textArea.value.split('\n');
                lines = lines.filter(Boolean);
                this.codeData = []
                lines.forEach((item,key)=>{
                    this.codeData.push({value:item,error:'',key:key})
                })
            })
        },
        // 切换
        handleClickTab(val){
            if(this.activeName == val){
                return false
            }
            this.activeName = val
            if(this.oldActiveName == val || val == 5){
                return  false
            } //记录一个旧的选中值，如果旧的值和当前选的值一样则不清除，选中的是5（已选编码）也不清除
            this.oldActiveName = val
            this.textareaValue = ''
            this.number = null
            this.rule = ''
            this.codeData = []
            this.hasError = false
        },
        // 清除
        handleClickDel(){
            this.textareaValue = ''
            this.codeData = []
            this.hasError = false
        },
        // 删除编码
        handleClickDelCode(item){
            this.codeData.splice(item.key,1)
            this.codeData.forEach((list,index) => {
                list.key = index
            })
            if(this.codeData.length == 0){
                this.textareaValue = ''
                this.codeData = []
                this.hasError = false
            }
        },

        // 全部清除已选编码
        handleClickDelSelected(){
            this.product_code_list = []
        },
        // 清除已选编码
        handleClickDelSelectedCode(item,key){
            this.product_code_list.splice(key,1)
        },


        handleInputText(item){
            var duplicates = this.codeData.filter(filte => filte.value === item.value);
            if(this.validateCodeInput(item.value) == false){
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”'
            }else if(item.value === '') {
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”'
            }else if(duplicates.length>1){
                item.error = '输入的编码内容重复'
            }else if(this.selectedCodeData.find(find => find == item.value)){
                item.error = '该编码已存在编码明细中，请重新输入'
            }else{
                item.error =  '';
            }
            this.codeData.forEach((item,key)=>{
                this.handleInput(item)
            })
        },

        validateCodeInput(value) {
            const regex = /^[a-zA-Z0-9\-/（）.~_<>\s]+$/;

            if (regex.test(value)) {
                return true;
            }
            // 如果都不符合，则返回 false
            return false;
        },
        handleInput(item){
            var duplicates = this.codeData.filter(filte => filte.value === item.value);

            if(this.validateCodeInput(item.value) == false){
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”'
            }else if(item.value === '') {
                item.error = '格式错误，请输入数字和字母的组合，纯英文或纯数字，特殊符号只支持“-”“/”“（）”“.”“~”“下划线”“<>”“空格”'
            }else if(this.selectedCodeData.find(find => find == item.value)){
                item.error = '该编码已存在编码明细中，请重新输入'
            }else if(duplicates.length>1){
                item.error = '输入的编码内容重复'
            }else{
                item.error =  '';
            }
        },

        handleDialogClose() {
            this.$emit("update:codeIdentificationDialog", false)
        },
        handleDialogConfirm() {
            if(this.hasError == false){
                if(this.activeName == 1 || this.activeName == 2){
                    var textArea = this.$refs.textareaValue
                    var lines = textArea.value.split('\n');
                    lines = lines.filter(Boolean);
                    this.codeData = []
                    lines.forEach((item,key)=>{
                        this.codeData.push({value:item,error:'',key:key})
                    })
                }
            }
            this.codeData.forEach((item,key)=>{
                this.handleInput(item)
            })
            const hasError = this.codeData.some(item => item.error !== '');
            this.hasError = hasError
            if(hasError){
                return false
            }
            this.textareaValue = this.codeData.map(item => item.value).join('\n')
            let code_type = this.activeName == 1 ? 'encoding_detection' : 'manual_entry_binding'
            this.BtnDisabled = true
            if(this.codeData.length > 0){
                if(this.productInfo && this.productInfo.name){

                    if(this.maxCodeIdentification != null){
                        if(this.codeData.length > this.maxCodeIdentification){
                            this.BtnDisabled = false
                            return  this.$message.error('该产品入库数量/产品编码合计不可超过待入库数量，最多可输入'+this.maxCodeIdentification+'个')
                        }
                    }
                    let postData = {
                        product_name: this.productInfo?this.productInfo.name : null,
                        sku_id:  this.productInfo?this.productInfo.sku_id : null,
                        sku_key:  this.productInfo?this.productInfo.sku_key : null,
                        type: code_type,
                        code_list: this.codeData.map(item => item.value),
                        related_detail_id:0,
                        source_type:this.sourceType
                    }
                    if(this.related_info && this.related_info.stock_pending_id){
                        postData.stock_pending_id = this.related_info.stock_pending_id
                        postData.related_type = this.related_info.related_type
                        postData.related_id = this.related_info.related_id
                    }
                    if(this.productInfo && this.productInfo.related_detail_id){
                        postData.related_detail_id = this.productInfo.related_detail_id
                    }
                    codeCheck(postData).then(res => {
                        if(res.code == 200){
                            let { not_found_code, unmatched_code,err_code} = res.data
                            this.codeData.forEach((item,key)=>{
                                let find = err_code.find(find => find.code == item.value)
                                if(find && find.code){
                                    this.hasError = true
                                    item.error = find.err_msg
                                }
                            })
                            this.BtnDisabled = false
                            if(this.hasError == true){
                                return false
                            }
                            let code_list = []
                            this.codeData.forEach(item=>{code_list.push(item.value)})
                            let data = {
                                type: code_type,
                                code_list:code_list,
                                selected_code_list : this.product_code_list, //上一次的编码
                                not_found_code : not_found_code, // 不存在的编码
                                unmatched_code : unmatched_code, //已存在未绑定的编码
                            }
                            this.$emit("success", data)
                            this.$emit("update:codeIdentificationDialog", false)
                        }
                        this.loading = false
                    })
                }else{
                    if(this.sourceType == 'out'){
                        let postData = {
                            code_list: this.codeData.map(item => item.value)
                        }
                        if(this.related_info && this.related_info.stock_pending_id){
                            postData.stock_pending_id = this.related_info.stock_pending_id
                            postData.related_type = this.related_info.related_type
                            postData.related_id = this.related_info.related_id
                        }
                        identifyCodeOut(postData).then(res => {
                            if(res.code == 200){
                                let {true_code,err_code} = res.data
                                this.codeData.forEach((item,key)=>{
                                    let find = err_code.find(find => find.code == item.value)
                                    if(find && find.code){
                                        this.hasError = true
                                        item.error = find.err_msg
                                    }
                                })
                                this.BtnDisabled = false
                                if(this.hasError == true){
                                    return false
                                }
                                let code_list = []
                                this.codeData.forEach(item=>{code_list.push(item.value)})
                                let data = {
                                    type: code_type,
                                    code_list:code_list,
                                }
                                this.$emit("success", data)
                                this.$emit("update:codeIdentificationDialog", false)
                            }else{
                                this.BtnDisabled = false
                            }
                            this.loading = false
                        })
                    }else if(this.sourceType == 'in'){
                        let postData = {
                            code_list: this.codeData.map(item => item.value)
                        }
                        if(this.related_info && this.related_info.stock_pending_id){
                            postData.stock_pending_id = this.related_info.stock_pending_id
                            postData.related_type = this.related_info.related_type
                            postData.related_id = this.related_info.related_id
                        }
                        identifyCodeIn(postData).then(res => {
                            if(res.code == 200){
                                let {true_code,err_code} = res.data
                                this.codeData.forEach((item,key)=>{
                                    let find = err_code.find(find => find.code == item.value)
                                    if(find && find.code){
                                        this.hasError = true
                                        item.error = find.err_msg
                                    }
                                })
                                this.BtnDisabled = false
                                if(this.hasError == true){
                                    return false
                                }
                                let code_list = []
                                this.codeData.forEach(item=>{code_list.push(item.value)})
                                let data = {
                                    type: code_type,
                                    code_list:code_list,
                                }
                                this.$emit("success", data)
                                this.$emit("update:codeIdentificationDialog", false)
                            }else{
                                this.BtnDisabled = false
                            }
                            this.loading = false
                        })
                    }

                }

            }else{

                if(this.activeNameList.indexOf(5) < 0 &&  this.product_code_list.length == 0){
                    this.BtnDisabled = false
                    this.$message.error('请输入产品编码')
                    return false
                }


                let data = {
                    type: code_type,
                    code_list:[],
                    selected_code_list : this.product_code_list, //上一次的编码
                    not_found_code : [], // 不存在的编码
                    unmatched_code : [], //已存在未绑定的编码
                }
                this.$emit("success", data)
                this.$emit("update:codeIdentificationDialog", false)
            }





        },

    }
}
</script>
<style  lang="scss" scoped>
@import "@/styles/inventory_management.scss";
</style>
